import { render } from "./portbanner.vue?vue&type=template&id=6927752a"
import script from "./portbanner.vue?vue&type=script&lang=js"
export * from "./portbanner.vue?vue&type=script&lang=js"

import "./portbanner.vue?vue&type=style&index=0&id=6927752a&lang=scss"

import exportComponent from "C:\\laragon\\www\\juani\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__